var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('v-snackbar',{attrs:{"color":_vm.notifyStatus,"timeout":_vm.notifyTimeout,"top":""},model:{value:(_vm.showNotify),callback:function ($$v) {_vm.showNotify=$$v},expression:"showNotify"}},[_c('div',[_vm._v(_vm._s(_vm.notifyText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }